import { Component } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthService, Credentials, UserService } from "@bt/core";
import { TokenError } from "./change-password.interfaces";
import { PasswordConfirmModel } from "@bt/core/models/passwordConfirm.model";
import { NotifierService } from 'angular-notifier';
import { e } from "@angular/core/src/render3";
import { BaseComponent } from "@bt/core/base";
@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"]
})
export class ChangePasswordComponent extends BaseComponent {
  public min6symbol:boolean = false;
  public error: TokenError;
  public showLoader: boolean = false;
  public sessionId: string = "";
  public code: string = "";
  public textError: string;
  public userId: string = "";
  private notifier: NotifierService;

  constructor(private userService: UserService, private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    notifierService: NotifierService) {
    super();
      this.notifier = notifierService;
      this.userService.clearAuth();
  }

  public change(passwordConfirmModel: PasswordConfirmModel) {

    var t = this;
    t.setLoading(true);

    this.route.queryParams.subscribe(params => {
        passwordConfirmModel.sessionId = params['sessionId'];
        passwordConfirmModel.code = params['code'];
        t.userId = params['userId'];
        t.setLoading(false);
    });
    this.userService.setPassword(passwordConfirmModel)
      .subscribe((resp) => {
        this.notifier.notify('success', 'Пароль успешно изменен');
        t.setLoading(false);

        const credentials: Credentials = {
          // здесь в качестве email выступает userId, с его помощью также можно авторизоваться
          email: t.userId,
          password: passwordConfirmModel.newPassword
        }
        this.authService
          .login(credentials)
          .subscribe(
            (response) => {
              this.userService
                .getUser()
                .then(
                  (response) => {
                      this.router.navigateByUrl("app/profile")
                        .then(() => this.showLoader = false);
                  },
                )
                .catch((error) => {
                  console.error(error.error);
                  t.setLoading(false);
                  this.notifier.notify('error', 'Пожалуйста выполните авторизацию');

                    this.authService.logout();
                });

            },
            (error: HttpErrorResponse) => {
              t.error = error.error;
              if (t.error != undefined && t.error.error_description != undefined) {

                t.textError = t.error.error_description;
                if (t.textError == "Invalid username or password")
                  t.textError = "Неправильный логин или пароль";
                var alert = document.getElementsByClassName("myalert");
                (<any>alert[0]).style.display = "block";
                setTimeout(function () { (<any>alert[0]).style.display = "none"; }, 4000)
              }

              console.log("Error:" + t.error.error_description);
              this.showLoader = false;
            }
          );

        }, (error) => {

          if(error.error.errorMsgs.includes("Code has been already used")){
          this.notifier.notify('error', 'Эта ссылка уже была активирована');
          }
          else{
            t.textError = error.error.errorMsgs[0];
            var alert = document.getElementsByClassName("myalert");
            (<any>alert[0]).style.display = "block";
            setTimeout(function () { (<any>alert[0]).style.display = "none"; }, 4000)
          }
          t.setLoading(false);
        })
  }

  public clearError() {
    this.error = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/public/change-password/change-password.component.ts